export default __webpack_public_path__ + "static/media/mallory_mp_compact_light_italic.59dce8f5.ttf";